<template>
  <div id="HomePage">
    <BannerSection></BannerSection>

    <!-- 产品模块（基准样式模块） -->
    <div class="service-section pt-80 pb-80">
      <img
        src="@/assets/images/bg/water-mark1.png"
        alt="水印"
        class="img-fluid water-mark1"
      />
      <img
        src="@/assets/images/bg/water-mark2.png"
        alt="水印"
        class="img-fluid water-mark2"
      />
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-8">
            <div
              class="section-title primary4 text-center wow fadeInUp"
              data-wow-duration="1.5s"
              data-wow-delay="0.1s"
            >
              <span>-我们能提供什么？-</span>
              <h3>我们的产品</h3>
              <p class="para">
                公司紧扣新质生产力发展脉搏，深耕医疗健康、电子政务与数字企业三大领域，围绕诊疗服务、政务办理、企业经营三类核心场景打造多款自主软件产品，为行业客户提供覆盖全业务链条的数字化能力
              </p>
            </div>
          </div>
        </div>
        <div class="row position-relative justify-content-center">
          <div class="swiper service-slider1 swiper-fix">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div
                  class="service-item1 wow fadeInUp"
                  data-wow-duration="1.5s"
                  data-wow-delay="0.2s"
                >
                  <div class="service-img">
                    <router-link to="/software" class="service-details-btn">
                      <img src="@/assets/images/icons/arrow.svg" alt="查看详情" />
                    </router-link>
                    <img
                      alt="医疗健康"
                      src="@/assets/images/bg/service11.png"
                      class="img-zoom"
                    />
                    <div class="overlay"></div>
                  </div>
                  <div class="service-content">
                    <div class="service-icon">
                      <img
                        src="@/assets/images/icons/webdev.svg"
                        alt="医疗健康"
                      />
                    </div>
                    <h4>
                      <router-link to="/software">医疗健康</router-link>
                    </h4>
                    <p class="para">
                       把就医、诊疗、院后服务、资产管理等各个环节数字化，助力医院持续提升服务与运营效率
                    </p>
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div
                  class="service-item1 wow fadeInUp"
                  data-wow-duration="1.5s"
                  data-wow-delay="0.4s"
                >
                  <div class="service-img">
                    <router-link to="/software" class="service-details-btn">
                      <img src="@/assets/images/icons/arrow.svg" alt="查看详情" />
                    </router-link>
                    <img
                      alt="电子政务"
                      src="@/assets/images/bg/service12.png"
                      class="img-zoom"
                    />
                    <div class="overlay"></div>
                  </div>
                  <div class="service-content">
                    <div class="service-icon">
                      <img
                        src="@/assets/images/icons/brandsolution.svg"
                        alt="电子政务"
                      />
                    </div>
                    <h4>
                      <router-link to="/software">电子政务</router-link>
                    </h4>
                    <p class="para">
                        为政务部门履行公共服务、社会管理和宏观调控提供支撑，助力跨部门数据共享与业务协同
                    </p>
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div
                  class="service-item1 wow fadeInUp"
                  data-wow-duration="1.5s"
                  data-wow-delay="0.6s"
                >
                  <div class="service-img">
                    <router-link to="/software" class="service-details-btn">
                      <img src="@/assets/images/icons/arrow.svg" alt="查看详情" />
                    </router-link>
                    <img
                      alt="数字企业"
                      src="@/assets/images/bg/service13.png"
                      class="img-zoom"
                    />
                    <div class="overlay"></div>
                  </div>
                  <div class="service-content">
                    <div class="service-icon">
                      <img
                        src="@/assets/images/icons/uiux.svg"
                        alt="数字企业"
                      />
                    </div>
                    <h4>
                      <router-link to="/software">数字企业</router-link>
                    </h4>
                    <p class="para">
                      围绕企业经营全流程定制软件开发和运营数据分析，把分散数据持续沉淀为可复用经营资产
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="slider-arrows text-center d-xl-flex d-none justify-content-between">
            <div class="service-prev1 swiper-prev-arrow arrow-hover">
              <svg
                width="46"
                height="46"
                viewBox="0 0 46 46"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="23" cy="23" r="22.25" stroke-width="1.5" />
                <path
                  d="M20 27.573V23V18.427C20 18.2574 19.8022 18.1648 19.672 18.2734L14 23L19.672 27.7266C19.8022 27.8352 20 27.7426 20 27.573Z"
                />
                <path
                  d="M32 23.5C32.2761 23.5 32.5 23.2761 32.5 23C32.5 22.7239 32.2761 22.5 32 22.5V23.5ZM19.672 27.7266L19.9921 27.3425V27.3425L19.672 27.7266ZM14 23L13.6799 22.6159L13.219 23L13.6799 23.3841L14 23ZM19.672 18.2734L19.3519 17.8893L19.3519 17.8893L19.672 18.2734ZM32 22.5H20V23.5H32V22.5ZM19.5 23V27.573H20.5V23H19.5ZM19.9921 27.3425L14.3201 22.6159L13.6799 23.3841L19.3519 28.1107L19.9921 27.3425ZM14.3201 23.3841L19.9921 18.6575L19.3519 17.8893L13.6799 22.6159L14.3201 23.3841ZM19.5 18.427V23H20.5V18.427H19.5ZM19.9921 18.6575C19.7967 18.8203 19.5 18.6814 19.5 18.427H20.5C20.5 17.8335 19.8078 17.5093 19.3519 17.8893L19.9921 18.6575ZM19.5 27.573C19.5 27.3186 19.7967 27.1797 19.9921 27.3425L19.3519 28.1107C19.8078 28.4907 20.5 28.1665 20.5 27.573H19.5Z"
                />
              </svg>
            </div>
            <div class="service-next1 swiper-next-arrow arrow-hover">
              <svg
                width="46"
                height="46"
                viewBox="0 0 46 46"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="23" cy="23" r="23" />
                <path
                  d="M26 18.427V23V27.573C26 27.7426 26.1978 27.8352 26.328 27.7266L32 23L26.328 18.2734C26.1978 18.1648 26 18.2574 26 18.427Z"
                />
                <path
                  d="M14 22.5C13.7239 22.5 13.5 22.7239 13.5 23C13.5 23.2761 13.7239 23.5 14 23.5V22.5ZM26.328 18.2734L26.0079 18.6575V18.6575L26.328 18.2734ZM32 23L32.3201 23.3841L32.781 23L32.3201 22.6159L32 23ZM26.328 27.7266L26.6481 28.1107L26.6481 28.1107L26.328 27.7266ZM14 23.5H26V22.5H14V23.5ZM26.5 23V18.427H25.5V23H26.5ZM26.0079 18.6575L31.6799 23.3841L32.3201 22.6159L26.6481 17.8893L26.0079 18.6575ZM31.6799 22.6159L26.0079 27.3425L26.6481 28.1107L32.3201 23.3841L31.6799 22.6159ZM26.5 27.573V23H25.5V27.573H26.5ZM26.0079 27.3425C26.2033 27.1797 26.5 27.3186 26.5 27.573H25.5C25.5 28.1665 26.1922 28.4907 26.6481 28.1107L26.0079 27.3425ZM26.5 18.427C26.5 18.6814 26.2033 18.8203 26.0079 18.6575L26.6481 17.8893C26.1922 17.5093 25.5 17.8335 25.5 18.427H26.5Z"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 行业数字化综合解决方案模块 -->
    <div class="about1-section honor-full-height d-flex align-items-center">
      <img
        src="@/assets/images/bg/brand-deco.svg"
        class="img-fluid section-bg1"
        alt="背景"
        data-speed="0.15"
      />

      <div class="container">
        <div class="row g-4 align-items-center">
          <div class="col-lg-6 order-lg-1 order-2">
            <div
              class="about1-content wow fadeInLeft"
              data-wow-duration="1.5s"
              data-wow-delay="0.2s"
            >
              <span>-我们的方向是什么？-</span>
              <h3><em>行业数字化</em>综合解决方案</h3>
              <p class="para">
                我们深耕行业信息化，面向医疗健康、电子政务与数字企业，提供从顶层规划到落地运营的一站式综合解决方案，以数字化能力助力行业客户高质量发展。
              </p>
              <ul class="feature-list">
                <li>
                  <!-- <span class="feature-num">01</span> -->
                  <span class="feature-text">以前瞻咨询与顶层设计，为客户厘清数字化转型的全局路径</span>
                </li>
                <li>
                  <!-- <span class="feature-num">02</span> -->
                  <span class="feature-text">贯通业务、数据与流程，以一体化融合能力孵化贴合场景的综合应用</span>
                </li>
                <li>
                  <!-- <span class="feature-num">03</span> -->
                  <span class="feature-text">以持续迭代与生态协同，让数字化投入沉淀为可度量的长期业务价值</span>
                </li>
              </ul>
              <!-- <p class="para">
                得益于贯通的数据与流程，三大板块得以复用经验。我们与客户一道理顺分散的信息化系统，让数据顺畅流转、业务线上闭环，陪伴客户从系统上线为标志的信息化，迈向数据驱动的数字化，再到具备自主判断能力的智能化。
              </p> -->
              <router-link
                to="/software/software1"
                class="eg-btn btn--primary btn--lg btn-hover-effect"
                >查看行业解决方案</router-link
              >
            </div>
          </div>
          <div class="col-lg-6 order-lg-2 order-1">
            <div
              class="about-images wow fadeInRight"
              data-wow-duration="1.5s"
              data-wow-delay="0.2s"
            >
              <img
                src="@/assets/images/20250724/gywm.jpg"
                class="img-fluid img-zoom-hover"
                alt="行业数字化解决方案"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 行业数字化卡片模块 -->
    <div class="industry-digit-section honor-full-height d-flex align-items-center">
      <div class="container" id="solutions_hangye">
        <div
          class="section-title primary2 text-center wow fadeInUp"
          data-wow-duration="1.5s"
          data-wow-delay="0.1s"
        >
          <span>-我们的能力是什么-</span>
          <h3>行业数字化</h3>
        </div>
        <div class="industry-card-container">
          <div
            class="team-member div_solution industry-card wow fadeInUp"
            data-wow-duration="1.2s"
            data-wow-delay="0.2s"
          >
            <a>
              <div class="image">
                <img
                  class="solution-img img-zoom"
                  src="@/assets/images/20250724/shuzihua/1.jpg"
                  alt="医疗健康"
                />
              </div>
              <div class="team-member-box">
                <div class="solutions_hangye_title">
                  <span>医疗健康</span>
                  <span class="solutions_hangye_title_en">Healthcare</span>
                </div>
                <p class="ind-summary">打通"三医"数据壁垒，支撑智慧就医、慢病管理与 AI 辅助诊疗落地，让居民就诊便捷、数据可用。</p>
              </div>
            </a>
          </div>
          <div
            class="team-member div_solution industry-card wow fadeInUp"
            data-wow-duration="1.2s"
            data-wow-delay="0.3s"
          >
            <a>
              <div class="image">
                <img
                  class="solution-img img-zoom"
                  src="@/assets/images/20250724/shuzihua/public-health.jpg"
                  alt="公共卫生"
                />
              </div>
              <div class="team-member-box">
                <div class="solutions_hangye_title">
                  <span>公共卫生</span>
                  <span class="solutions_hangye_title_en">Public Health</span>
                </div>
                <p class="ind-summary">紧扣"健康中国"要求，贯通疾控与救治链条，支撑公卫事件早发现早处置，提升区域治理处置能力。</p>
              </div>
            </a>
          </div>
          <div
            class="team-member div_solution industry-card wow fadeInUp"
            data-wow-duration="1.2s"
            data-wow-delay="0.4s"
          >
            <a>
              <div class="image">
                <img
                  class="solution-img img-zoom"
                  src="@/assets/images/20250724/shuzihua/3.jpg"
                  alt="电子政务"
                />
              </div>
              <div class="team-member-box">
                <div class="solutions_hangye_title">
                  <span>电子政务</span>
                  <span class="solutions_hangye_title_en">E-Government</span>
                </div>
                <p class="ind-summary">以"一网通办、一网统管"整合政务数据，打破部门孤岛，支撑跨部门协同，也让办事与治理更高效。</p>
              </div>
            </a>
          </div>
          <div
            class="team-member div_solution industry-card wow fadeInUp"
            data-wow-duration="1.2s"
            data-wow-delay="0.5s"
          >
            <a>
              <div class="image">
                <img
                  class="solution-img img-zoom"
                  src="@/assets/images/20250724/shuzihua/4.jpg"
                  alt="数字企业"
                />
              </div>
              <div class="team-member-box">
                <div class="solutions_hangye_title">
                  <span>数字企业</span>
                  <span class="solutions_hangye_title_en">Enterprise</span>
                </div>
                <p class="ind-summary">贯通企业经营全流程数据，把沉淀业务数据转为经营洞察与决策力，让管理有据可依、节奏沉稳可控。</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- 公司优势模块 -->
    <div id="Service" class="service-section full-screen-section">
      <div class="container Service-container h-100">
        <div class="row justify-content-center">
          <div class="col-md-8">
            <div
              class="section-title primary1 text-center wow fadeInUp"
              data-wow-duration="1.5s"
              data-wow-delay="0.1s"
            >
              <span>-我们的优势是什么？-</span>
              <h3>我们的优势</h3>
            </div>
          </div>
        </div>

        <!-- 优势卡片列表：与独立页 /advantage 同款（方形图+编号+中英双标题+玫红短线） -->
        <div class="adv-grid">
          <div
            class="adv-card wow fadeInUp"
            v-for="(item, index) in serviceList"
            :key="item.id"
            data-wow-duration="1.2s"
            :data-wow-delay="0.12 * (index + 1) + 's'"
            @click="ServiceClick(item.id)"
          >
            <div class="adv-media">
              <img :src="item.img" :alt="item.title" />
            </div>
            <div class="adv-body">
              <h4 class="adv-title">{{ item.title }}</h4>
              <p class="adv-en">{{ item.eng_title }}</p>
              <span class="adv-line"></span>
              <p class="adv-desc">{{ item.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 荣誉资质模块 -->
    <div id="honor" class="service-section honor-full-height d-flex align-items-center">
      <div class="container">
        <div
              class="section-title text-center mb-5 wow fadeInUp"
              data-wow-duration="1.5s"
              data-wow-delay="0.1s"
            >
              <span>-荣誉资质-</span>
              <h3>荣誉资质</h3>
        </div>
        <div class="honor-card-container">
          <div
            class="honor-card wow fadeInUp"
            data-wow-duration="1.2s"
            data-wow-delay="0.2s"
            v-for="(item, index) in honorList"
            :key="index"
          >
            <div class="honor-img-box">
              <!-- 证书位图 -> HTML 复刻（与 newsinformation 页同一规范） -->
              <CertReplica :cert="item.cert" class="honor-img img-zoom-hover" />
            </div>
            <h4 class="honor-title">{{ item.title }}</h4>
          </div>
        </div>
        <!--
        <p class="cert-disclaimer">说明：页面展示为证书样式示意，非扫描件；资质信息以主管部门公示及证书原件为准。</p>
        -->
        <div
          class="text-center mt-5 wow fadeInUp"
          data-wow-duration="1.2s"
          data-wow-delay="0.5s"
        >
          <router-link
            to="/newsinformation"
            class="btn btn-theme btn-hover-effect"
            style="color: #1d2b48"
          >
            更多荣誉 <i class="fa fa-fw fa-angle-double-right"></i>
          </router-link>
        </div>
      </div>
    </div>

    <!-- 合作伙伴模块 -->
    <div
      id="whyChooseUs"
      class="service-section honor-full-height d-flex align-items-center"
    >
      <div class="container">
        <div
              class="section-title text-center mb-5 wow fadeInUp"
              data-wow-duration="1.5s"
              data-wow-delay="0.1s"
            >
              <span>-合作客户-</span>
              <h3>合作客户</h3>
            <!-- <p class="para" style="max-width:760px;margin:0 auto 30px;text-align:center;">我们的客户与生态伙伴覆盖医疗、通信、政务、金融与文旅等行业，在各类信息化项目中协同共建。</p> -->
        </div>
        <div class="wow fadeInUp" data-wow-duration="1.5s" data-wow-delay="0.2s">
          <PartnerMarquee :list="partnerList" />
        </div>
        <p class="partner-note">以上客户排序不分先后。</p>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import { WOW } from "wowjs";
import BannerSection from "./components/BannerSection.vue";
import CertReplica from "@/components/CertReplica.vue";
import PartnerMarquee from "@/components/PartnerMarquee.vue";
import partnerList from "@/assets/data/partners.js";

export default {
  name: "HomePage",
  components: {
    BannerSection,
    CertReplica,
    PartnerMarquee,
  },
  data() {
    return {
      // 公司优势数据（与独立页 /advantage 同款：title + eng_title + desc + img）
      serviceList: [
        {
          id: "section-1",
          title: "高效的服务能力",
          eng_title: "Efficient Service Capability",
          desc: "需求快速响应，问题定点解决，实施节奏按客户实际场景灵活调整",
          img: require("@/assets/images/pic21.png"),
        },
        {
          id: "section-2",
          title: "资深的行业专家经验",
          eng_title: "Professional Industry Experts",
          desc: "深耕医疗与政务信息化多年，行业顾问全程参与需求梳理与方案设计",
          img: require("@/assets/images/pic22.png"),
        },
        {
          id: "section-3",
          title: "先进的技术应用架构",
          eng_title: "Advanced Technology Architecture",
          desc: "微服务架构，配套统一数据中台与智能分析能力，便于扩展与系统对接",
          img: require("@/assets/images/pic23.png"),
        },
        {
          id: "section-4",
          title: "完备的交付体系",
          eng_title: "Complete Delivery System",
          desc: "分阶段确认、持续迭代交付，关键节点评审留痕，变更全程可追溯",
          img: require("@/assets/images/pic24.png"),
        },
      ],
      // 荣誉资质数据
      honorList: [
        {
          cert: "gaoxin",
          title: "国家级高新技术企业",
        },
        {
          cert: "keji",
          title: "国家科技型中小企业",
        },
        {
          cert: "chuangxin",
          title: "海南省创新型中小企业",
        },
        {
          cert: "zhongzi",
          title: "海南省高新技术种子企业",
        },
      ],
      // 合作伙伴数据（来源 @/assets/data/partners.js，可只填名称、logo 留空）
      partnerList,
    };
  },
  mounted() {
    // 初始化滚动动画
    new WOW({
      live: false,
      offset: 100,
      mobile: true,
    }).init();

    // 初始化产品轮播
    new Swiper(".service-slider1", {
      slidesPerView: 3,
      speed: 800,
      spaceBetween: 30,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      loop: true,
      roundLengths: true,
      effect: "slide",
      grabCursor: true,
      navigation: {
        nextEl: ".service-next1",
        prevEl: ".service-prev1",
      },
      breakpoints: {
        280: { slidesPerView: 1, navigation: false },
        480: { slidesPerView: 1, navigation: false },
        768: { slidesPerView: 2, navigation: false },
        992: { slidesPerView: 2 },
        1200: { slidesPerView: 3 },
      },
    });

    // 视差滚动效果（仅保留其他背景的视差）
    this.initParallax();
  },
  methods: {
    // 优势卡片点击跳转
    ServiceClick(index) {
      const routes = [
        "",
        "/Solution/Solution1",
        "/Solution/Solution6",
        "/Solution/Solution8",
        "/Solution/Solution10",
      ];
      if (routes[index]) {
        this.$router.push({ path: routes[index] });
      }
    },
    // 初始化视差滚动
    initParallax() {
      const parallaxElements = document.querySelectorAll(".parallax-bg");

      window.addEventListener("scroll", () => {
        parallaxElements.forEach((element) => {
          const speed = element.getAttribute("data-speed") || 0.5;
          const yPos = -(window.scrollY * speed);
          element.style.transform = `translateY(${yPos}px)`;
        });
      });
    },
  },
};
</script>

<style scoped>
/* 定义主颜色变量 */
:root {
  --primary-color-medium: rgba(230, 0, 76, 0.15);
}

/* 全局基础样式 */
.service-section,
.about1-section,
.industry-digit-section {
  overflow: hidden;
}

/* 全局标题统一 */
.section-title h3,
.about1-content h3,
.Service-title,
.customer-title,
.whyChooseUs-title p {
  font-size: 42px;
  font-weight: 700;
  color: #1d2b48;
  line-height: 1.3;
  margin-bottom: 20px;
}

/* 大标题移动端自适应：窄屏逐级缩小。
   原为固定 42px —— 手机上不随屏幕缩放（顶栏 h1 已缩到 25.6px），
   长标题（如"行业数字化综合解决方案"）被挤成两行、与主标题层级倒挂。
   用媒体查询而非 clamp()：本项目预渲染/校验所用 Chrome 78 不支持 clamp()。 */
@media (max-width: 991px) {
  .section-title h3,
  .about1-content h3,
  .Service-title,
  .customer-title,
  .whyChooseUs-title p {
    font-size: 34px;
  }
}

@media (max-width: 575px) {
  .section-title h3,
  .about1-content h3,
  .Service-title,
  .customer-title,
  .whyChooseUs-title p {
    font-size: 26px;
  }
}

.section-title span,
.about1-content span {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1px;
  margin-bottom: 10px;
  display: inline-block;
}

/* 眉标：色条 + 文字（scoped 的 inline-block 会压掉全局 inline-flex，这里补回） */
.about1-content span {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.para {
  font-size: 16px;
  line-height: 1.8;
  color: #666;
}

/* 行业数字化能力三列并列 */
.about1-content .feature-list {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin: 24px 0;
  padding: 0;
  list-style: none;
}

.about1-content .feature-list li {
  flex: 1 1 calc(33.333% - 14px);
  min-width: 220px;
  background: #fff;
  border-radius: 16px;
  padding: 28px 22px;
  box-shadow: 0 4px 20px rgba(29, 43, 72, 0.08);
  border: 1px solid #e6e8ed;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  overflow: hidden;
}

.about1-content .feature-list li::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: #e6004c;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.4s ease;
}

.about1-content .feature-list li:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 32px rgba(29, 43, 72, 0.14);
  border-color: #e6004c;
}

.about1-content .feature-list li:hover::before {
  transform: scaleX(1);
}

.about1-content .feature-list .feature-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: rgba(230, 0, 76, 0.1);
  color: #e6004c;
  font-size: 15px;
  font-weight: 700;
  border-radius: 10px;
  margin-bottom: 16px;
}

.about1-content .feature-list .feature-text {
  display: block;
  font-size: 15px;
  line-height: 1.75;
  color: #676767;
}

@media (max-width: 991px) {
  .about1-content .feature-list li {
    flex: 1 1 100%;
  }
}

/* 行业数字化卡片样式 */
.team-member.div_solution {
  border: 2px solid #e6e8ed;
  border-radius: 0;
  background: #fff;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  overflow: hidden;
  position: relative;
}

.team-member.div_solution::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: var(--primary-color1);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.4s ease;
}

.team-member.div_solution:hover::before {
  transform: scaleX(1);
}

.team-member.div_solution:hover {
  border-color: var(--primary-color1);
  box-shadow: 0 15px 40px var(--primary-opcaity);
  transform: translateY(-10px);
}

.team-member.div_solution .solution-img {
  width: 100%;
  height: 180px;
  object-fit: cover;
  transition: transform 0.6s ease;
}

.team-member.div_solution:hover .solution-img {
  transform: scale(1.1);
}

.team-member-box {
  padding: 25px 20px;
  transition: all 0.4s ease;
}

.solutions_hangye_title {
  text-align: center;
  margin-bottom: 15px;
}

.solutions_hangye_title span:first-child {
  font-size: 20px;
  font-weight: 600;
  color: #1d2b48;
  display: block;
  transition: color 0.3s ease;
}

.team-member.div_solution:hover .solutions_hangye_title span:first-child {
  color: var(--primary-color1);
}

.solutions_hangye_title_en {
  font-size: 13px;
  color: var(--primary-color1);
  text-transform: uppercase;
  letter-spacing: 1px;
  opacity: 0.8;
  transition: opacity 0.3s ease;
}

.team-member.div_solution:hover .solutions_hangye_title_en {
  opacity: 1;
}

/* 公司优势模块样式 */
#Service {
  min-height: calc(100vh - 80px);
  /*
   * 2026-09-15 选 C 定稿：极浅品牌蓝灰 #EAF0F6（取标题深蓝 #1d2b48 同色系浅调，告别粉色感；玫红仅作小面积强调）。
   * 底层：#EAF0F6 实色浅底（非透明叠色），与邻块 #ffffff / #f8f8f8 清晰区隔且不显粉。
   * 渐变：用户要求恢复"渐变效果"，09-15 在 C 底盘上叠蓝灰同色系对角线性渐变 + 两层 5%~6% 品牌角光（非粉色铺底）。
   * 叠加层（与首屏 banner 同源的"双柔光"语言，整体压低以适配浅底；本版为 B 更含蓄方案，透明度再压淡约 30%）：
   *   1) 右上角玫红柔光 radial-gradient（0.12→0，扩散至 55%）—— 主氛围光；
   *   2) 左下角紫玫柔光 radial-gradient（0.09→0，扩散至 56%）—— 辅助对角色；
   *   3) 135° 对角线性渐变玫瑰洗（0.05→0，55% 处过渡完）—— 制造方向感、避免纯平。
   * 全部为平滑渐变，无点阵/纹理，规避"斑点"观感；文字仍深字 #18212E / 标题 #1d2b48。
   * 历史：曾用近黑底 → 深海蓝 #2b3d78 硬边（09-11）→ 浅底+点阵柔光（用户评斑点丑，09-14 改纯渐变）→ 四候选 A/B/C/D（纯白/极浅冷灰蓝/极浅品牌蓝灰/极浅青灰）选 C 定稿（09-15）。
   */
  background-color: #EAF0F6;
  /* 渐变层次（2026-09-15 用户要求恢复"渐变效果"）：蓝灰同色系对角线性渐变作主层次（左上更亮→右下略深，制造方向感），
     再叠两层极低透明度品牌玫红角光（5%~6%）作品牌呼吸感；整体不显粉、无点阵/纹理。 */
  background-image:
    linear-gradient(135deg, #EFF4F9 0%, #EAF0F6 45%, #DCE7F2 100%),
    radial-gradient(100% 80% at 100% 0%, rgba(230, 0, 76, 0.05), rgba(230, 0, 76, 0) 60%),
    radial-gradient(120% 85% at 50% 112%, rgba(230, 0, 76, 0.06), rgba(230, 0, 76, 0) 60%);
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  color: #18212E;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  overflow: hidden;
  position: relative;
}

/* 底部装饰线稿：品牌色渐变描边、纯线条无填色，呼应首屏 banner 的轨道/涟漪语言；
   刻意不用任何点阵/小圆点，规避用户否定的"斑点"观感。opacity 控制在 0.12 保持克制。 */
#Service::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 46%;
  background-image: url("../assets/images/bg/service-deco.svg");
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: contain;
  opacity: 0.12;
  pointer-events: none;
  z-index: 0;
}

#Service .container {
  position: relative;
  z-index: 1;
}

#Service .section-title h3 {
  color: #1d2b48;
  font-size: 42px;
  font-weight: 700;
}

/* #Service（我们的优势）标题自适应：id 选择器优先级高于上面的类选择器，需单独覆盖 */
@media (max-width: 991px) {
  #Service .section-title h3 {
    font-size: 34px;
  }
}

@media (max-width: 575px) {
  #Service .section-title h3 {
    font-size: 26px;
  }
}

#Service .section-title p.para {
  color: rgba(255, 255, 255, 0.85);
  font-size: 16px;
  line-height: 1.8;
}

/* ===== 优势卡片：与独立页 /advantage 同款（方形图+编号+中英双标题+玫红短线） ===== */
.adv-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 28px;
  justify-content: center;
  align-items: stretch;
  width: 100%;
  margin: 50px 0 0;
}

.adv-card {
  flex: 1 1 calc(25% - 28px);
  max-width: 292px;
  min-width: 250px;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #eceef2;
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  box-shadow: 0 2px 10px rgba(16, 24, 40, 0.03);
  transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275),
    box-shadow 0.4s ease, border-color 0.4s ease;
}

/* 顶部玫红进度条：hover 时从左铺满 */
.adv-card::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 3px;
  background: #e6004c;
  transition: width 0.45s ease;
  z-index: 3;
}

.adv-card:hover::after {
  width: 100%;
}

.adv-card:hover {
  transform: translateY(-8px);
  border-color: rgba(230, 0, 76, 0.28);
  box-shadow: 0 18px 38px rgba(16, 24, 40, 0.1);
}

/* ===== 图片区：固定比例 + 中心裁切（老内核不用 aspect-ratio） ===== */
.adv-media {
  position: relative;
  width: 100%;
  padding-top: 76%;
  overflow: hidden;
  background: #f5f6f8;
}

.adv-media img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.6s ease;
}

.adv-card:hover .adv-media img {
  transform: scale(1.06);
}

/* ===== 信息区 ===== */
.adv-body {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  padding: 22px 22px 24px;
  text-align: center;
}

.adv-title {
  font-size: 19px;
  font-weight: 600;
  color: #1d2b48;
  line-height: 1.45;
  margin: 0 0 8px;
  transition: color 0.3s ease;
}

.adv-card:hover .adv-title {
  color: #e6004c;
}

.adv-en {
  font-family: poppins, sans-serif;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #9aa3b2;
  line-height: 1.5;
  margin: 0 0 12px;
}

/* 玫红短线：标题区与描述区的分隔（品牌色） */
.adv-line {
  display: inline-block;
  width: 26px;
  height: 3px;
  border-radius: 2px;
  background: #e6004c;
  margin: 0 auto 14px;
  transition: width 0.45s ease;
}

.adv-card:hover .adv-line {
  width: 42px;
}

.adv-desc {
  font-size: 13px;
  line-height: 1.75;
  color: #676767;
  margin: 0;
}

/* 公司优势响应式 */
@media (max-width: 1199px) {
  .adv-card {
    flex: 1 1 calc(50% - 28px);
    max-width: 360px;
  }
}

@media (max-width: 767px) {
  .adv-grid {
    gap: 20px;
  }

  .adv-card {
    flex: 1 1 100%;
    max-width: 420px;
  }

  .adv-body {
    padding: 20px 18px 22px;
  }
}

/* 公司优势标题颜色：浅底背景下，眉标走 primary1 玫红胶囊（来自 .section-title.primary1 span），
   主标题走 #1d2b48 深字（来自上方 #Service .section-title h3）。
   历史：曾用 !important 白字覆盖（深底时代），现浅底已不需要，删除避免遮蔽 primary1 胶囊。 */

/* 全屏高度统一类 */
.honor-full-height {
  min-height: calc(100vh - 80px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  overflow: hidden;
}

/* 荣誉资质模块样式 */
.honor-card-container {
  display: flex;
  flex-wrap: wrap;
  gap: 40px 30px;
  justify-content: center;
  align-items: stretch;
  width: 100%;
  max-width: 1200px;
  margin: 50px auto 0;
  padding: 0;
}

.honor-card {
  flex: 0 0 calc(25% - 22.5px);
  max-width: calc(25% - 22.5px);
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  text-align: center;
  margin-top: 20px;
  position: relative;
  overflow: hidden;
}

.honor-card::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: var(--primary-color1);
  transform: scaleX(0);
  transform-origin: right;
  transition: transform 0.4s ease;
}

.honor-card:hover::after {
  transform: scaleX(1);
  transform-origin: left;
}

.honor-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 16px 32px rgba(0, 0, 0, 0.15);
}

.honor-img-box {
  width: 100%;
  height: auto; /* 证书复刻版按 4:5 竖版自适应高度，不再固定 200px 裁切 */
  margin-bottom: 15px;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.4s ease;
}

/* 合规免责：证书为版式示意 */
.cert-disclaimer {
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: #676767;
  margin: 8px 0 0;
}

.honor-card:hover .honor-img-box {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.honor-img {
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.6s ease;
}

.honor-card:hover .honor-img {
  transform: scale(1.05);
}

.honor-title {
  font-size: 18px;
  font-weight: 600;
  color: #1d2b48;
  margin: 0;
  transition: color 0.3s ease;
}

.honor-card:hover .honor-title {
  color: var(--primary-color1);
}

/* 荣誉资质响应式 */
@media (max-width: 1199px) {
  .honor-card {
    margin-top: 25px;
  }
}

@media (max-width: 991px) {
  .honor-card {
    flex: 0 0 calc(50% - 15px);
    max-width: calc(50% - 15px);
    margin-top: 30px;
  }
}

@media (max-width: 575px) {
  .honor-card {
    flex: 0 0 100%;
    max-width: 100%;
    margin-top: 40px;
  }
}

/* 合作伙伴模块样式 */
#whyChooseUs {
  background: #efefef;
  min-height: calc(100vh - 80px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  overflow: hidden;
}

/* 合作伙伴：HTML 卡片网格（参考 daohuasoft：白底 logo 区 + 名称条） */
.partner-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 24px 20px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.partner-box {
  background: #ffffff;
  border: 1px solid #f0f0f0;
  border-radius: 2px;
  overflow: hidden;
  /* 纵向弹性：logo 区固定、名称区自适应，保证同行卡片等高 */
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}

.partner-box:hover {
  transform: translateY(-4px);
  border-color: rgba(230, 0, 76, 0.25);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06), 0 8px 24px rgba(0, 0, 0, 0.08);
}

.partner-box-logo {
  height: 118px;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px 16px;
  background: #ffffff;
}

.partner-box-logo img {
  max-width: 82%;
  max-height: 74px;
  object-fit: contain;
  /* 官方 logo 保持真实色彩（原为 grayscale(25%)），避免第三方标识失真 */
  transition: opacity 0.3s ease;
}

.partner-box-placeholder {
  display: inline-flex;
  color: #e6004c;
  opacity: 0.5;
}

.partner-box-name {
  flex: 1 1 auto;
  min-height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 10px;
  color: #444444;
  font-size: 14px;
  line-height: 1.4;
  text-align: center;
  border-top: 1px solid #f2f2f2;
  transition: color 0.3s ease;
}

.partner-box:hover .partner-box-name {
  color: #e6004c;
}

.partner-note {
  text-align: center;
  color: #676767;
  font-size: 12px;
  margin: 24px 0 0;
}

@media (max-width: 767px) {
  .partner-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px 12px;
  }
  .partner-box-logo {
    height: 92px;
  }
  .partner-box-name {
    font-size: 13px;
  }
}

/* 行业数字化卡片模块样式 */
.industry-digit-section {
  background: #ffffff;
}

.industry-card-container {
  display: flex;
  flex-wrap: wrap;
  gap: 40px 30px;
  justify-content: center;
  align-items: stretch;
  width: 100%;
  max-width: 1200px;
  margin: 50px auto 0;
  padding: 0;
}

.industry-card {
  flex: 0 0 calc(25% - 22.5px);
  max-width: calc(25% - 22.5px);
  margin-top: 20px;
}

/* 行业数字化响应式 */
@media (max-width: 1199px) {
  .industry-card {
    flex: 0 0 calc(33.333% - 20px);
    max-width: calc(33.333% - 20px);
    margin-top: 25px;
  }
}

@media (max-width: 991px) {
  .industry-card {
    flex: 0 0 calc(50% - 15px);
    max-width: calc(50% - 15px);
    margin-top: 30px;
  }
}

@media (max-width: 575px) {
  .industry-card {
    flex: 0 0 100%;
    max-width: 100%;
    margin-top: 40px;
  }
}

/* 行业数字化综合解决方案样式 */
.about1-section {
  position: relative;
  background: #f7f8fa;
}

.about1-section .container {
  position: relative;
  z-index: 1;
}



/* 按钮悬停效果 */
.btn-hover-effect {
  position: relative;
  overflow: hidden;
  z-index: 1;
  transition: all 0.4s ease;
}

.btn-hover-effect::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s ease;
  z-index: -1;
}

.btn-hover-effect:hover::before {
  left: 100%;
}

.btn-hover-effect:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 20px var(--primary-color-medium);
}

/* 箭头按钮悬停效果 */
.arrow-hover {
  transition: all 0.3s ease;
  cursor: pointer;
}

.arrow-hover:hover {
  transform: scale(1.1);
}

.arrow-hover:hover svg circle {
  fill: var(--primary-color1);
  stroke: var(--primary-color1);
}

.arrow-hover:hover svg path {
  fill: #fff;
}

/* 图片缩放效果 */
.img-zoom {
  transition: transform 0.6s ease;
}

.img-zoom-hover {
  transition: transform 0.6s ease;
}

.img-zoom-hover:hover {
  transform: scale(1.05);
}

/* 视差背景 */
.parallax-bg {
  transition: transform 0.1s linear;
}

/* 行业四卡：政策-技术-产品-成效 四线结构 */
.ind-summary {
  margin: 14px 0 0;
  font-size: 13px;
  line-height: 1.8;
  color: #5a6270;
  text-align: center;
}
@media (max-width: 575px) {
  .ind-summary {
    font-size: 13.5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/HomePage.vue